import { buildHeadersWithWidgetToken } from '@elfsight/lib-utils';
import { API_URL } from '../../constants';

export type UnvoteResponse = {
  code: number;
  message: string;
  payload: {};
};

export async function unvoteQuery(
  pid: string,
  widgetToken: string | undefined
) {
  const headers = buildHeadersWithWidgetToken(widgetToken, {
    'content-type': 'application/json'
  });

  const response = await fetch(`${API_URL}/api/poll`, {
    method: 'DELETE',
    headers,
    body: JSON.stringify({
      vote: { pid }
    })
  });

  const { code, message, payload }: UnvoteResponse = await response.json();

  if (code === 401) {
    throw new Error(message);
  }

  return payload;
}
